import Vue from 'vue';
import { types as userTypes } from './user';
import {
  onSnapshot,
  firestoreCollection,
  firestoreDocumentByPath,
  createNewId,
} from '../firebase/firestore';

const MODULE_PREFIX = 'tags';
const GETTER_ORGANIZATION_TAGS = 'organizationTags';
const GETTER_USER_TAGS = 'userTags';
const ACTION_ADD_USER_TAGS = 'addUserTags';
const ACTION_FETCH_ORGANIZATION_TAGS = 'fetchOrganizationTags';
const ACTION_FETCH_USER_TAGS = 'fetchUserTags';
const MUTATION_USER_TAGS = 'MUTATION_USER_TAGS';
const MUTATION_ORGANIZATION_TAGS = 'MUTATION_ORGANIZATION_TAGS';

const initialState = {
  organization: [],
  user: [],
};

const mapTag = (source) => (tagSnapshot) => ({
  text: tagSnapshot.data().text,
  refPath: tagSnapshot.ref.path,
  id: tagSnapshot.id,
  source,
});

const onSnapshotOrganizationTags = (commit, snapshot) => {
  console.log('onSnapshotOrganizationTags');
  const tags = snapshot.docs.map(mapTag('organization'));
  commit(MUTATION_ORGANIZATION_TAGS, tags);
};

const onSnapshotUserTags = (commit, snapshot) => {
  console.log('onSnapshotUserTags');
  const tags = snapshot.docs.map(mapTag('user'));
  commit(MUTATION_USER_TAGS, tags);
};

const actions = {
  [ACTION_ADD_USER_TAGS]: async ({ rootGetters }, { tags }) => {
    const userDetails = rootGetters[userTypes.getters.userDetails];
    const { userId } = userDetails;

    const saved = await Promise.all(tags.map(async (tag) => {
      const documentId = createNewId();
      const refPath = `/users/${userId}/tags/${documentId}`;
      const doc = firestoreDocumentByPath(refPath);

      await doc.set({
        id: documentId,
        text: tag,
        timestamp: Date.now(),
      });

      return {
        text: tag,
        refPath,
        id: documentId,
        source: 'user',
      };
    }));
    return saved;
  },
  [ACTION_FETCH_ORGANIZATION_TAGS]: async ({ commit, rootGetters }) => {
    console.log('fetchOrganizationTags');
    const userDetails = rootGetters[userTypes.getters.userDetails];
    const { organizationId } = userDetails;
    const query = firestoreCollection(`organizations/${organizationId}/tags`);

    onSnapshot(query, onSnapshotOrganizationTags.bind(this, commit));
  },
  [ACTION_FETCH_USER_TAGS]: async ({ commit, rootGetters }) => {
    const userDetails = rootGetters[userTypes.getters.userDetails];
    const { userId } = userDetails;
    const query = firestoreCollection(`users/${userId}/tags`);

    onSnapshot(query, onSnapshotUserTags.bind(this, commit));
  },
};
const mutations = {
  [MUTATION_USER_TAGS]: (state, tags) => {
    Vue.set(state, 'user', tags);
  },
  [MUTATION_ORGANIZATION_TAGS]: (state, tags) => {
    Vue.set(state, 'organization', tags);
  },
};

const getters = {
  [GETTER_ORGANIZATION_TAGS]: state => state.organization,
  [GETTER_USER_TAGS]: state => state.user,
};

export default {
  namespaced: true, state: initialState, getters, mutations, actions,
};

export const types = {
  getters: {
    userTags: `${MODULE_PREFIX}/${GETTER_USER_TAGS}`,
    organizationTags: `${MODULE_PREFIX}/${GETTER_ORGANIZATION_TAGS}`,
  },
  mutations: {
    USER_TAGS: `${MODULE_PREFIX}/${MUTATION_USER_TAGS}`,
    ORGANIZATION_TAGS: `${MODULE_PREFIX}/${MUTATION_ORGANIZATION_TAGS}`,
  },
  actions: {
    addUserTags: `${MODULE_PREFIX}/${ACTION_ADD_USER_TAGS}`,
    fetchOrganizationTags: `${MODULE_PREFIX}/${ACTION_FETCH_ORGANIZATION_TAGS}`,
    fetchUserTags: `${MODULE_PREFIX}/${ACTION_FETCH_USER_TAGS}`,
  },
};
